import React from 'react'
import { array, func, element, object } from 'prop-types'
import BaseServiceFilter from './BaseServiceFilter'
import FilterButton from './buttons/FilterButton'
import { ReactComponent as TuneVariant } from '../assets/tune-variant.svg'
import { Box, Popover } from '@mui/material'

// Campos que são padrão permanente e não devem contar como "filtro ativo"
const IGNORED_FILTER_FIELDS = ['ano_id']

function countActiveFilters(filters = {}) {
  return Object.entries(filters).filter(
    ([key, value]) =>
      !IGNORED_FILTER_FIELDS.includes(key) &&
      value !== undefined &&
      value !== null &&
      value !== ''
  ).length
}

export default function BaseFilter({
  filter,
  onChange = () => {},
  components,
  filters
}) {
  const [anchorElFilter, setAnchorElFilter] = React.useState(null)

  const activeCount = countActiveFilters(filters)

  const handleOpenFilterMenu = event => {
    setAnchorElFilter(event.currentTarget)
  }
  const handleCloseFilterMenu = () => {
    setAnchorElFilter(null)
  }

  return (
    <Box sx={{ flexGrow: 0, display: 'flex', maxWidth: '100px' }}>
      <FilterButton
        sx={{
          position: 'fixed !important',
          right: '0 !important',
          top: '25% !important',
          minWidth: '50px !important',
          height: '50px !important',
          background: 'rgba(200, 200, 200, 0.7) !important',
          borderRadius: '8px 0 0 8px !important',
          cursor: 'pointer !important'
        }}
        bg="#000000BF"
        Icon={TuneVariant}
        activeCount={activeCount}
        onClick={handleOpenFilterMenu}
      />
      <Popover
        sx={{
          mt: '45px',
          minWidth: '300px',
          '& .MuiPaper-elevation': {
            overflowY: 'inherit',
            overflowX: 'inherit',
            maxWidth: '360px'
          }
        }}
        id="menu-appbar"
        anchorEl={anchorElFilter}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElFilter)}
        onClose={handleCloseFilterMenu}
      >
        {filter?.map((item, index) => (
          <div
            style={{ minWidth: '300px', padding: '0.5rem 0.75rem' }}
            key={index}
            onClick={e => e.stopPropagation()}
          >
            <BaseServiceFilter
              filter={item}
              onChange={value => {
                onChange(value)
              }}
            />
          </div>
        ))}
        {components && (
          <div
            style={{
              minWidth: '300px',
              padding: '0.5rem 0.75rem'
            }}
          >
            {components}
          </div>
        )}
      </Popover>
    </Box>
  )
}

BaseFilter.propTypes = {
  filter: array,
  onChange: func,
  components: element,
  filters: object
}
